import React from 'react';

// Deterministic initials avatar — replaces the old admin's random Metronic
// avatar SVGs (which changed on every render and lived in /metronic/assets).
const PALETTE = [
    { backgroundColor: '#EFEAFE', color: '#5B3FE0' },
    { backgroundColor: '#DBEAFE', color: '#1E40AF' },
    { backgroundColor: '#D1FAE5', color: '#065F46' },
    { backgroundColor: '#FEF3C7', color: '#92400E' },
    { backgroundColor: '#FEE2E2', color: '#991B1B' },
    { backgroundColor: '#E0E7FF', color: '#3730A3' },
];

const getInitials = (name) => {
    if (!name) return '?';
    const parts = String(name).trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
};

const hash = (str) => {
    let h = 0;
    for (let i = 0; i < str.length; i++) {
        h = (h * 31 + str.charCodeAt(i)) | 0;
    }
    return Math.abs(h);
};

const SIZE_CLASSES = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-10 w-10 text-sm',
    lg: 'h-12 w-12 text-base',
};

const AvatarCircle = ({ name, size = 'md', className = '' }) => (
    <span
        className={`inline-flex items-center justify-center rounded-full font-bold flex-shrink-0 select-none ${SIZE_CLASSES[size] || SIZE_CLASSES.md} ${className}`}
        style={PALETTE[hash(String(name || '?')) % PALETTE.length]}
    >
        {getInitials(name)}
    </span>
);

export default AvatarCircle;
